import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chat-maximize",
  "use": "chat-maximize-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"chat-maximize\"><path fill=\"none\" stroke=\"#A4A4AD\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M11 1h5v5M6 16H1v-5M16 1l-5.833 5.833M1 16l5.833-5.833\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol